import { motion } from "framer-motion"

export const PageHeader = ({ title }: { title: string; icon?: string }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0, animationDuration: 0.5 }}
      viewport={{ once: true }}
    >
      <div className="flex items-center p-6 sm:py-12">
        <h2 className="text-[clamp(1rem,calc(2vw+1rem),7rem)] font-extrabold text-orange-500">
          {title}
        </h2>
      </div>
    </motion.div>
  )
}
